import { productIdFormat, supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const addProductsToSupplier = {
  name: "addProductsToSupplier" as const,
  input: z.object({
    supplierIds: z.array(supplierIdFormat.schema),
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ addedCount: z.number().int() }),
};
